/* ag-v85.js - AquaGrip CT (v85, 27 Oct 2026, Claude)
   1. Helm studio: no more "close it and it loads again".
      The helm studio (snippets/aquagrip-design-studio.liquid, AGCT v61) reloads
      the page onto the Shopify variant the design needs (?variant=..&studio=1)
      so Easify prices correctly, 1.2 s after a change. A fresh visitor lands on
      "With Custom Logo" while a new design starts as "Custom Dimensions No
      Logo" (43821141721148), so opening the studio always reloaded once - and
      closing it inside that 1.2 s let the reload fire anyway and reopen it.
      a) Links/buttons that open the helm studio from a page with no ?variant
         go straight to ?variant=43821141721148&studio=1: one load, not two.
      b) Closing the studio blocks a still-pending reload (the studio's own
         20 s sessionStorage guard, ag_vswap_<id>) and drops studio=1 / #studio
         from the address so a refresh doesn't reopen it. Opening the studio
         again lifts the block, so real variant swaps during a build still run.
   2. Title case for hero and section headlines on the studio pages and the
      home studio band (small words stay lower case; words that already have
      capitals - CNC, 3M, Studio - are left alone). */
(function(){
  'use strict';
  if(window.__agv85) return; window.__agv85 = true;

  /* ---------- 1. helm studio ---------- */
  var HELM = '/products/custom-aquagrip-boat-helm-pads', HV = '43821141721148';
  var STUDIO_URL = HELM + '?variant=' + HV + '&studio=1';
  function wantsHelmStudio(href){
    if(!href) return false;
    var u; try{ u = new URL(href, location.href); }catch(e){ return false; }
    if(u.origin !== location.origin || u.pathname.replace(/\/$/, '') !== HELM) return false;
    if(u.searchParams.get('variant')) return false;
    return /^#(studio|build)$/i.test(u.hash) || u.searchParams.get('studio') === '1';
  }
  function onHelm(){ return location.pathname.replace(/\/$/, '') === HELM; }
  document.addEventListener('click', function(e){
    if(e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href], [data-ag-open-studio]') : null;
    if(!a) return;
    var helmLink = a.hasAttribute('href') && wantsHelmStudio(a.getAttribute('href'));
    /* on the helm page itself, the in-page "open the studio" buttons */
    var inPage = onHelm() && a.hasAttribute('data-ag-open-studio') && !new URL(location.href).searchParams.get('variant');
    if(!helmLink && !inPage) return;
    if(helmLink && onHelm() && new URL(location.href).searchParams.get('variant')) return; /* already on a variant: open in place */
    e.preventDefault(); e.stopImmediatePropagation();
    location.href = STUDIO_URL;
  }, true);

  if(onHelm()){
    var stamped = [];
    function variantIds(){
      var ids = [];
      try{ (window.ShopifyAnalytics.meta.product.variants || []).forEach(function(v){ ids.push(String(v.id)); }); }catch(e){}
      return ids;
    }
    function blockSwaps(){
      var now = String(Date.now());
      variantIds().forEach(function(id){ try{ sessionStorage.setItem('ag_vswap_' + id, now); stamped.push(id); }catch(e){} });
    }
    function liftBlock(){
      stamped.forEach(function(id){ try{ sessionStorage.removeItem('ag_vswap_' + id); }catch(e){} });
      stamped = [];
    }
    function cleanUrl(){
      try{
        var u = new URL(location.href), changed = false;
        if(u.searchParams.has('studio')){ u.searchParams.delete('studio'); changed = true; }
        if(/^#(studio|build)$/i.test(u.hash)){ u.hash = ''; changed = true; }
        if(changed) history.replaceState(history.state, '', u.pathname + (u.search ? u.search : '') + u.hash);
      }catch(e){}
    }
    var tries = 0;
    (function watch(){
      var ov = document.getElementById('agsOverlay');
      if(!ov){ if(++tries < 80) setTimeout(watch, 150); return; }
      var wasOn = ov.classList.contains('on');
      new MutationObserver(function(){
        var isOn = ov.classList.contains('on');
        if(isOn === wasOn) return;
        wasOn = isOn;
        if(isOn) liftBlock(); else { blockSwaps(); cleanUrl(); }
      }).observe(ov, {attributes:true, attributeFilter:['class']});
    })();
  }

  /* ---------- 2. title case ---------- */
  var SMALL = /^(a|an|and|as|at|but|by|for|in|of|on|or|the|to|vs|via|nor|with|per)$/i;
  function titleCase(el){
    if(el.__tc) return; el.__tc = true;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while((n = walker.nextNode())) nodes.push(n);
    var words = [];
    nodes.forEach(function(node, ni){
      node.nodeValue.replace(/\S+/g, function(w, off){ words.push({node:ni, off:off, w:w}); return w; });
    });
    var capNext = true;
    var out = nodes.map(function(x){ return x.nodeValue; });
    var shift = nodes.map(function(){ return 0; });
    words.forEach(function(it, i){
      var w = it.w, core = w.replace(/[^a-z]/gi, ''), nw = w;
      if(w === w.toLowerCase() && /[a-z]/.test(w)){
        var last = i === words.length - 1;
        if(capNext || last || !SMALL.test(core)){
          nw = w.replace(/[a-z]/, function(c){ return c.toUpperCase(); });
          /* hyphenated words: cut-outs -> Cut-Outs, all-day -> All-Day */
          nw = nw.replace(/-([a-z])/g, function(m, c){ return '-' + c.toUpperCase(); });
        }
      }
      if(nw !== w){
        var s = out[it.node], p = it.off + shift[it.node];
        out[it.node] = s.slice(0, p) + nw + s.slice(p + w.length);
        shift[it.node] += nw.length - w.length;
      }
      capNext = /[.!?:]["”']?$/.test(w);
    });
    nodes.forEach(function(node, k){ if(node.nodeValue !== out[k]) node.nodeValue = out[k]; });
  }
  function runTitleCase(){
    Array.prototype.forEach.call(document.querySelectorAll(
      '.ags-page h1, .ags-page h2, .ags-page .agn-spec-head .k, section[data-agsp] .agsp-head h2'
    ), titleCase);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runTitleCase); else runTitleCase();
})();
